module.exports = __webpack_public_path__ + "static/share-dee110c649a4613527a76746fe38ad6f.png";